"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RowActionColumn = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _Menu = _interopRequireDefault(require("@civicplus/preamble/lib/Menu/Menu"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var RowActionColumn = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(RowActionColumn, _Component);

  var _super = _createSuper(RowActionColumn);

  function RowActionColumn() {
    var _this;

    (0, _classCallCheck2["default"])(this, RowActionColumn);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "render", function () {
      var _this$props = _this.props,
          actions = _this$props.actions,
          id = _this$props.id;
      return /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
        size: "small",
        id: id,
        type: "action",
        items: actions,
        stopPropagation: true
      });
    });
    return _this;
  }

  return RowActionColumn;
}(_react.Component);

exports.RowActionColumn = RowActionColumn;
(0, _defineProperty2["default"])(RowActionColumn, "displayName", "RowActionColumn");
(0, _defineProperty2["default"])(RowActionColumn, "propTypes", {
  /**
   * The html id
   */
  id: _propTypes["default"].string,

  /**
   * Actions to be performed on a per row basis
   */
  actions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    /**
     * The display string for the action
     */
    display: _propTypes["default"].string,

    /**
     * Array containing actions to be performed
     */
    actions: _propTypes["default"].array
  }))
});
var _default = RowActionColumn;
exports["default"] = _default;